
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Head, Steps, themes } from "mdx-deck";
import recursiveFactorial from './images/recursiveFactorial.png'
import recursiveMenu from './images/recursiveMenu.gif'
import recursiveStart from './images/recursiveStart.png'
import recursiveDataType from './images/recursiveDataType.png'
import recursiveComponents from './images/recursiveComponents.png'
import recursiveDevTool from './images/recursiveDevTool.png'
import goodbye from './images/goodbye.gif'
export const theme = themes.book;
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Head mdxType="Head">
  <title>UI Recursive Rendering</title>
    </Head>
    <h1>{`🚀 UI Recursive Rendering 🏎`}</h1>
    <h2><a style={{
        textDecoration: 'none'
      }} href="https://namnguyen.design/" target="\_blank">{`Nam Nguyen`}</a></h2>
    <hr></hr>
    <h1>{`🍦 Example of recursion 🍦`}</h1>
    <img style={{
      height: "80%",
      width: "90%",
      objectFit: "contain"
    }} src={recursiveFactorial} alt="Recursive Factorial" border="0" />
    <hr></hr>
    <h1>{`🌲 Use case: Nested menus 🌲`}</h1>
    <img style={{
      height: "80%",
      width: "90%",
      objectFit: "contain"
    }} src={recursiveMenu} alt="Recursive Start" border="0" />
    <hr></hr>
    <h1>{`🍄 Start with a sample app 🍄`}</h1>
    <img style={{
      height: "80%",
      width: "90%",
      objectFit: "contain"
    }} src={recursiveStart} alt="Recursive Menu" border="0" />
    <hr></hr>
    <h1>{`❄️ Sample Data Type ❄️`}</h1>
    <img style={{
      height: "80%",
      width: "90%",
      objectFit: "contain"
    }} src={recursiveDataType} alt="Recursive Data Type" border="0" />
    <hr></hr>
    <h1>{`🍓 Recursive Components 🍓`}</h1>
    <img style={{
      height: "80%",
      width: "90%",
      objectFit: "contain"
    }} src={recursiveComponents} alt="Recursive Components" border="0" />
    <hr></hr>
    <h1>{`🛠 Devtool Presentation 🛠`}</h1>
    <img style={{
      height: "80%",
      width: "90%",
      objectFit: "contain"
    }} src={recursiveDevTool} alt="Recursive DevTool" border="0" />
    <hr></hr>
    <h1>{`🎉 Thanks for your attention 🎉`}</h1>
    <img style={{
      height: "80%"
    }} src={goodbye} alt="Goodbye" border="0" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;